import React, { useState } from "react";
import Collapsible from "react-collapsible";
import "./styles.scss";
import NoticeCard from "../NoticeCard";
import CurrencyText from "../CurrencyText";
import { useTranslation } from "react-i18next";

const CustomCollapsible = ({
  children,
  cardHeading,
  open,
  onClick,
  openedIcon,
  closedIcon,
  headingClass,
  collapsibleWrapperClasses,
  isSVGIcon = false,
  OpenedSVGIcon,
  ClosedSVGIcon,
  leftIcon,
  collapsibleWrapperClassOpen,
  collapsibleWrapperClassClose,
  noteHeading,
  noteDescription,
  noteIcon,
  noteBackgroundColor,
  hasOtherInfoCard,
  otherInfoCardData,
}) => {
  const [isOpen, setIsOpen] = useState(open);
  const { t } = useTranslation();

  return (
    <div
      className={`collapsible-container ${collapsibleWrapperClasses} ${isOpen ? collapsibleWrapperClassOpen : collapsibleWrapperClassClose}`}
    >
      <Collapsible
        handleTriggerClick={() => setIsOpen((prev) => !prev)}
        open={isOpen}
        trigger={
          <div className="collapsible-trigger-container">
            <div className="d-flex align-items-center gap-1">
              {leftIcon ? (
                <img
                  src={leftIcon}
                  alt="left-icon"
                  className="left-icon ms-0"
                />
              ) : null}
              {cardHeading && (
                <span className={`collapsible-heading ${headingClass}`}>
                  {cardHeading}
                </span>
              )}
            </div>
            {isSVGIcon ? (
              <React.Fragment>
                {isOpen ? (
                  <OpenedSVGIcon className="collapsible-svg-icon" />
                ) : (
                  <ClosedSVGIcon className="collapsible-svg-icon" />
                )}
              </React.Fragment>
            ) : (
              <img
                src={isOpen ? openedIcon : closedIcon}
                alt="collapsible-icon"
                className="collapsible-icon"
              />
            )}
          </div>
        }
      >
        {children}
        {noteHeading || noteDescription ? (
          <NoticeCard
            containerStyle={{
              margin: "0px",
              marginTop: "12px",
              padding: "8px",
            }}
            backgroundColor={noteBackgroundColor}
            icon={noteIcon}
            headingText={noteHeading ? noteHeading : ""}
            descriptionText={noteDescription ? noteDescription : ""}
            descriptionValues={{ installmentDueDate: 40 }}
          />
        ) : null}
        {hasOtherInfoCard ? (
          <div className="other-info-key-value-card">
            {otherInfoCardData?.map((infoData) => (
              <div className="other-info-key-value-item">
                <p className="item-label">{t(infoData?.label)}</p>
                <p className="item-value">
                  <CurrencyText value={infoData?.value} />
                </p>
              </div>
            ))}
          </div>
        ) : null}
      </Collapsible>
    </div>
  );
};

export default CustomCollapsible;
